import DefaultImage from "/assets/img/ic_upload_image.svg";

export default () => {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      replaceInvalidImage: "@vuiReplaceInvalidImage"
    },
    link: (scope, element) => {

      element.on("error", () => element.attr('src', scope.replaceInvalidImage || DefaultImage));
    }
  };
}